// @docs https://[domain]/api/v1/docs
export default {
  List13thSalary: "/pyr/get-13th",
  UpdateBonus: "/pyr/update-13th/{id}",
  DeleteBonus: "/pyr/delete-13th/{id}",
};
